import { createSlice } from '@reduxjs/toolkit';
import {fetchCommunityHomeownerData } from '../CommunityAPI/communityApi';

const fetchCommunityHomeownerSlice = createSlice({
  name: 'fetchCommunityHomeowner',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(fetchCommunityHomeownerData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCommunityHomeownerData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchCommunityHomeownerData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
  },
});

export default fetchCommunityHomeownerSlice.reducer;
